import { SegmentedControl } from "@/components/toggle/segmented-control";
import { FoodLibraryList } from "@/features/meal-plan/components/food-library-list";
import {
  resolveSavedMealsTab,
  SAVED_MEALS_TAB_OPTIONS,
  SavedMealsTabValue,
} from "@/features/meal-plan/constants/saved-meals-tabs";
import { useSearchParams } from "@/hooks/router/use-search-params";
import { cn } from "@/utils/cn";
import { IonContent, IonPage, useIonRouter } from "@ionic/react";
import { memo, useRef } from "react";

const SavedMealsPage = memo(function SavedMealsPage() {
  const router = useIonRouter();
  const searchParams = useSearchParams();
  const pageRef = useRef<HTMLElement>(null);
  const requestedTab = searchParams.get("tab");
  const selectedTab = resolveSavedMealsTab(requestedTab);
  // const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  // const handleSearchClick = () => {
  //   setIsSearchModalOpen(true);
  // };

  return (
    <IonPage ref={pageRef}>
      <IonContent>
        <div className="safe-area-top relative mx-auto flex h-full max-w-[450px] flex-col">
          <div
            key={selectedTab}
            className={cn(
              "absolute top-[calc(var(--safe-area-inset-top)+4rem)] right-0 left-0 z-0 h-10 w-full blur-3xl",
              {
                "bg-[radial-gradient(circle_at_center,var(--color-your-foods)_0%,var(--color-your-foods)_35%)]":
                  selectedTab === "your-food",
              },
            )}
          />
          <div className="relative z-10 flex flex-1 flex-col overflow-hidden">
            <div className="relative flex items-center justify-between gap-3 p-5">
              <SegmentedControl
                options={SAVED_MEALS_TAB_OPTIONS}
                value={selectedTab}
                onChange={(value) => {
                  const urlSearchParams = new URLSearchParams(searchParams);
                  urlSearchParams.set("tab", value as SavedMealsTabValue);
                  router.push(`/plans/saved-meals?${urlSearchParams.toString()}`, "none");
                }}
                classNames={{
                  container: "flex-1 bg-white",
                }}
              />

              {/* <TextButton className="w-fit" onClick={handleSearchClick}>
                <SearchIcon className="h-5 w-5 text-gray-700" />
              </TextButton> */}
            </div>

            <div
              className="no-scrollbar relative flex-1 overflow-y-auto px-4 py-4 pb-24"
              data-scroll-container
            >
              <FoodLibraryList tab={selectedTab} />
            </div>
          </div>
        </div>

        {/* <SearchFoodModal
          pageRef={pageRef}
          isOpen={isSearchModalOpen}
          onDismiss={() => setIsSearchModalOpen(false)}
          mode={selectedTab}
        /> */}
      </IonContent>
    </IonPage>
  );
});

export default SavedMealsPage;
